import {create} from 'zustand'
import type {UsuarioDto} from '../types'

interface UsuarioState {
  usuario: UsuarioDto
  definirUsuario: (usuario: UsuarioDto) => void
}

const usuarioInicial: UsuarioDto = {
  name: null,
  email: null,
  code: null,
  isFornecedor: null,
  userRoles: [],
}

export const useUsuarioStore = create<UsuarioState>(set => ({
  usuario: usuarioInicial,
  definirUsuario: usuario => set({usuario}),
}))
